document.querySelectorAll('[data-adev-t-accordion="group"]:not(.adev-init)').forEach((group) => {

    group.classList.add('adev-init');
    
    group.querySelectorAll('[data-adev-t-accordion="item"]').forEach((item) => {
        const title = item.querySelector('[data-adev-accordion="title"]');
        const content = item.querySelector('[data-adev-accordion="content"]');

        title.addEventListener('click', (e) => {
            e.preventDefault();
            
            const currentlyActiveItem = group.querySelector('[data-adev-t-accordion="item"].active');
            
            if (currentlyActiveItem && currentlyActiveItem !== item) {
                currentlyActiveItem.classList.remove('active');
                const activeContent = currentlyActiveItem.querySelector('[data-adev-accordion="content"]');
                activeContent.style.maxHeight = '0';
            }

            if (item.classList.contains('active')) {
                item.classList.remove('active');
                content.style.maxHeight = '0';
            } else {
                item.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });

});

// Suppress Klaviyo popup sign-up forms from displaying
window.addEventListener('klaviyoForms', function(e) {
  if (e && e.detail && (e.detail.type === 'open' || e.detail.type === 'embedOpen')) {
    document.querySelectorAll('.klaviyo-form, [class*="kl-private-reset-css-wrapper"], [data-testid*="klaviyo"]').forEach(function(el) {
      el.remove();
    });
  }
});